import { getStoreById, storeData } from './data-utils';
import Events from './events';

const internal = {
  goTo: (view) => (window.location.hash = view),

  goToMap: (store_id, showRoute = false) => {
    const store = getStoreById(store_id);
    const [storeLocation] = store.storeLocations || [];
    const currentStore = {
      store,
      storeLocation,
      showRoute,
    };
    storeData('currentStore', currentStore);
    internal.goTo('maps');
  },
};

export default {
  goTo: internal.goTo,

  goBack() {
    window.history.back();
  },

  searchMapFeatures() {
    internal.goTo('search');
  },

  showNewsArticle(id) {
    storeData('currentArticle', id);
    internal.goTo('news');
  },

  showStoreInfo(id) {
    const store = getStoreById(id);
    storeData('currentStore', { store });
    Events.dispatchEvent('poi', { name: store.name, action: 'popup' });
    internal.goTo('store');
  },

  showStoreOnMap(id) {
    internal.goToMap(id);
  },

  showRouteToStore(id) {
    internal.goToMap(id, true);
  },

  showTipsForStore(id) {
    storeData('currentStore', {
      store: { id },
      storeLocation: {},
      showRoute: false,
    });
    internal.goTo('tips');
  },

  showFacilityOnMap(id) {
    storeData('currentStore', {
      facility: id,
    });
    internal.goTo('maps');
  },
};
